import gql from "graphql-tag"
import {FlexiPointsExpiry, QueryFlexiPointsExpiryListArgs, QueryTopupCurrencyCodeArgs, QueryWalletArgs, Wallet} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import walletQuery from "../graph/query/wallet"
import flexiPointsExpiryList, {flexiPointsExpiryListKey} from "../services/queries/flexiPointsExpiryList"
import walletErrorHandler from "../services/errors/walletErrorHandler"
import {NextTopup, WalletFragment} from "../graph/fragments/fullWallet"
import topupCurrencyCode, {topupCurrencyCodeKey} from "../services/queries/getCurrencyCode"

export const useWalletQuery = createUseQuery<Wallet, QueryWalletArgs>(walletQuery, {
  key: "wallet",
  errorHandlers: [walletErrorHandler]
})

export const useFlexiPointsExpiryQuery = createUseQuery<FlexiPointsExpiry, QueryFlexiPointsExpiryListArgs>(flexiPointsExpiryList, {
  key: flexiPointsExpiryListKey
})

export const useWalletWithNextTopupQuery = createUseQuery<Wallet, QueryWalletArgs>(
  gql`
    query Wallet($userId: String!, $currency: String!, $entityId: ID, $entityType: WalletEntityType) {
      wallet(userId: $userId, entityId: $entityId, currency: $currency, entityType: $entityType) {
        ...WalletFragment
        ...NextTopup
      }
    }

    ${WalletFragment}
    ${NextTopup}
  `,
  {
    key: "wallet",
    errorHandlers: [walletErrorHandler]
  }
)

export const useTopupCurrencyQuery = createUseQuery<string, QueryTopupCurrencyCodeArgs>(topupCurrencyCode, {
  key: topupCurrencyCodeKey
})
